module.exports = __webpack_public_path__ + "static/media/nutritionix.e5b8c360.svg";